import { Injectable } from '@angular/core';
import { EditorFieldConfig, EditorFieldType, EditorSpecialItemType } from '@fleet-beat/editor';
import { EditorItemConfig, EditorSpecialFieldConfig } from '../models/editor-item-type';
import { EditorColumnConfig } from '../models/editor-column-config.model';
import { EditorTitleConfig } from '../models/editor-title-config.model';
import { DataSelectConfig } from '../models/fields/data-select-config.model';
import { TemplatedFieldConfig } from '../models/fields/templated-field-config.model';

@Injectable({ providedIn: 'root' })
export class EditorConfigHelperService {
  isEditorFieldConfig(item: EditorItemConfig | EditorColumnConfig): item is EditorFieldConfig {
    if (!item) {
      return false;
    }

    const editorFieldConfig: EditorFieldConfig = item as EditorFieldConfig;

    return !!(
      editorFieldConfig.label ||
      editorFieldConfig.placeholder ||
      editorFieldConfig.type === EditorFieldType.TEMPLATE
    );
  }

  isEditorTitleConfig(item: EditorItemConfig | EditorColumnConfig): item is EditorTitleConfig {
    return item && (item as EditorTitleConfig).type === EditorSpecialItemType.Title;
  }

  isDataSelectConfig(item: EditorItemConfig | EditorColumnConfig): item is DataSelectConfig {
    if (!item) {
      return false;
    }

    return (
      item.type === EditorFieldType.SELECT_DATA ||
      (item as TemplatedFieldConfig).templateType === EditorFieldType.SELECT_DATA
    );
  }

  isEditorSpecialFieldConfig(item: EditorItemConfig | EditorColumnConfig): item is EditorSpecialFieldConfig {
    if (!item) {
      return false;
    }

    return !!(item as EditorSpecialFieldConfig).editor;
  }
}
